module.exports = __webpack_public_path__ + "Letter of Medical Necessity.pdf";